export default __webpack_public_path__ + "static/media/07_Auctioneers-Commercial-EschweilerPhotography_M1A6775.ad72b1b9.jpg";